import React from 'react'
import { AppRouter } from './routers/appRouter'

const MainRouter = () => {
  return <AppRouter />
}

export default MainRouter
